<template>
  <div>
    <h2>Williamite War (1688-1691)</h2>
    <h3>Order of Battle/Record of Engaged Unit</h3>
    <div class="image">
      <img src="@/assets/images/IrishHistory/james-second.jpg" alt="James Second" />
      <i>
        <h5>Contemporary Image of the Army of James II</h5>
      </i>
    </div>
    <h3>Army of James II</h3>
    <h4>Horse</h4>

    <h5>Royal Regiment of Horse</h5>
    <p class="padding">
      Boyne
      <br />Red turned back blue
    </p>
    <br />
    <h5>Viscount Galmoy's</h5>
    <p class="padding">
      Moyry Pass
      <br />Limerick
    </p>
    <br />
    <h5>Abercorne’s</h5>
    <p class="padding">Aughrim</p>
    <br />
    <h5>Colclough’s</h5>
    <p class="padding">Limerick (1691)</p>
    <br />
    <h5>Kilmarnock’s</h5>
    <p class="padding">Limerick (1690)</p>

    <br />
    <h5>Luttrell</h5>

    <p class="padding">
      Enniskillen
      <br />Sligo (1689)
      <br />Dublin Garrison (winter 1689)
      <br />Aughrim
    </p>

    <br />
    <h5>Parker's</h5>
    <p class="padding">
      Boyne
      <br />Aughrim
    </p>

    <br />
    <h5>Pendergast’s</h5>

    <p class="padding">Aughrim</p>

    <br />
    <h5>Purcel</h5>

    <p class="padding">Boyne</p>

    <br />
    <p class="padding">Limerick (1691)</p>

    <br />
    <h5>Sarsfield’s</h5>
    <p class="padding">
      Ballyshannon
      <br />Sligo (1689)
      <br />Cavan
      <br />Boyne
      <br />Ballineety Raid
      <br />Castle Birr
      <br />Aughrim
    </p>

    <br />
    <h5>Sheldon’s</h5>
    <p class="padding">
      Boyne
      <br />Aughrim
      <br />Limerick (1691)
    </p>

    <br />
    <h5>Sunderland's</h5>
    <p class="padding">
      Boyne
      <br />Aughrim
    </p>

    <br />
    <h5>Duke of Tyrconnell's</h5>
    <p class="padding">Boyne</p>

    <br />
    <h5>Westmeath’s</h5>

    <h4>Dragoons</h4>
    <h5>Maxwell’s</h5>

    <p class="padding">
      Boyne
      <br />Limerick (1690)
      <br />Althone (1691)
    </p>
    <br />
    <h5>Lord Clare’s</h5>
    <p class="padding">
      Derry
      <br />Boyne
    </p>
    <br />
    <h5>Clifford’s</h5>
    <p class="padding">
      Limerick (1690)
      <br />Limerick (1691)
    </p>
    <br />
    <h5>Cotter</h5>
    <h5>Lord Dungan</h5>
    <p class="padding">Boyne</p>
    <h5>O’Brien</h5>
    <p class="padding">
      Sligo
      <br />Boyne
    </p>
    <br />
    <h5>O’Gara’s</h5>

    <p class="padding">Boyne</p>

    <h5>O’Neill’s</h5>

    <p class="padding">
      Boyne
      <br />White turned back brown
    </p>
    <br />

    <h5>Talbot’s</h5>

    <p class="padding">Limerick (1690)</p>

    <h4>Foot</h4>
    <h5>Royal Regiment of Foot Guards</h5>
    <p class="padding">
      Derry
      <br />Boyne
      <br />Aughrim
      <br />Red turned back blue
    </p>
    <br />
    <h5>Earl of Antrim's (Scots/Antrim) (“Redshanks”)</h5>
    <p class="padding">
      Derry
      <br />Boyne
      <br />Althone
      <br />Aughrim
      <br />Limerick
      <br />White turned
      back red
    </p>
    <br />
    <h5>Barret’s</h5>
    <p class="padding">Waterford Garrison</p>
    <br />
    <h5>Bagenal’s</h5>
    <p class="padding">Derry</p>
    <br />
    <h5>Lord Bellew’s</h5>
    <p class="padding">
      Derry
      <br />Moyry Pass
      <br />Newry (1690)
      <br />Ballymore Fort
      <br />Aughrim
      (Lord Bellew captured and dies of wounds)
      <br />Red turned back tawney
    </p>
    <br />
    <h5>Berwick’s</h5>
    <p class="padding">
      Enniskillen
      <br />Derry
      <br />Cavan
      <br />Limerick (1690)
      <br />Castle Birr
      <br />Cork
      <br />Limerick (1691)
    </p>
    <br />
    <h5>Maj. Gen Boisseleau’s</h5>
    <p class="padding">
      Newry
      <br />Boyne
      <br />Limerick (1690)
      <br />Limerick (1691)
    </p>
    <br />
    <h5>Bophin’s</h5>
    <p class="padding">Aughrim</p>
    <br />
    <h5>Bourke’s</h5>
    <p class="padding">
      Lanesborough
      <br />Ballymore Fort
      <br />Aughrim
    </p>
    <h5>Burke’s</h5>
    <p class="padding">Duncannon</p>
    <br />
    <h5>Butler’s</h5>
    <p class="padding">Derry</p>
    <br />
    <h5>Cavanaugh’s</h5>
    <p class="padding">Waterford Garrison</p>
    <br />
    <h5>Earl of Clancarty</h5>
    <p class="padding">
      Derry
      <br />Butchers Gate
      <br />Boyne Cork
      <br />Aughrim
      <br />Galway
    </p>
    <br />
    <h5>Clifford’s</h5>
    <p class="padding">
      Lanesborough
      <br />Ballymore Fort
      <br />Limerick (1691)
    </p>
    <br />
    <h5>Dillon’s</h5>
    <p class="padding">
      Ballymore Fort
      <br />Aughrim
      <br />Galway
      <br />Limerick (1691)
    </p>
    <br />
    <h5>Dorrington’s</h5>
    <p class="padding">Aughrim</p>
    <br />
    <br />

    <h5>Lord Duncan</h5>
    <p class="padding">Boyne</p>
    <h5>Eustace’s</h5>
    <p class="padding">
      Limerick (1690)
      <br />Ballymore Fort
      <br />Red turned back yellow
    </p>
    <h5>Fitzgerald’s</h5>
    <p class="padding">Althone</p>
    <h5>Lord Grand Prior's (Fitzjames)</h5>
    <p class="padding">
      Dublin Garrison (winter 1689)
      <br />Boyne
      <br />Limerick (1690)
      <br />Althone (1691)
      <br />Aughrim
      <br />Limerick (1691)
      <br />Red turned back white/red breeches
    </p>
    <h5>Galmoy</h5>
    <p class="padding">
      Enniskillen
      <br />Siege of Crom Castle
      <br />Newry (1690)
    </p>

    <h5>Lord Galway’s</h5>
    <p class="padding">Bir Castle</p>
    <br />
    <h5>Gormanston’s</h5>
    <p class="padding">Ballymore Fort</p>
    <br />
    <h5>Goughegan</h5>
    <p class="padding">Ballymore Fort</p>
    <br />
    <h5>Grace’s</h5>
    <p class="padding">
      Althone (1690)
      <br />>Althone (1691)
    </p>
    <br />
    <h5>Hamilton’s</h5>
    <p class="padding">
      Dromore
      <br />Derry
      <br />Pennyburn Mill
      <br />Boyne
      <br />Coleriane
      <br />Aughrim
    </p>
    <br />
    <h5>Lord Iveagh’s</h5>
    <p class="padding">Droghea Garrison during Battle of the Boyne</p>
    <br />
    <h5>Lord Louth’s</h5>
    <p class="padding">Newry (1689)</p>
    <br />
    <h5>MacCarty Mor’s</h5>
    <p class="padding">Carrickfergus</p>
    <br />
    <h5>Owen MacCarty</h5>
    <p class="padding">Carrickfergus</p>
    <br />
    <h5>MacDonogh’s</h5>
    <p class="padding">
      Sligo (1691)
      <br />Ballyshannon
    </p>
    <br />
    <h5>MacElligott’s</h5>
    <p class="padding">
      Boyne
      <br />Cork
    </p>
    <br />
    <br />

    <h5>Maguire’s</h5>
    <p class="padding">Aughrim</p>
    <h5>McMahon’s</h5>
    <p class="padding">
      Limerick (1690)
      <br />Althone
    </p>
    <h5>Moore’s</h5>
    <p class="padding">
      Ballymore Fort
      <br />Sligo
      <br />Aughrim
    </p>
    <h5>Nugent’s</h5>
    <p class="padding">
      Derry
      <br />Kenagh
      <br />Cavan
    </p>
    <h5>O’Donnell ( Ulster) (Went over to William III at Sligo)</h5>
    <p class="padding">Sligo (1691)</p>
    <h5>O’Gara’s</h5>
    <p class="padding">
      Jamestown
      <br />Sligo (1691)
      <br />Althone
    </p>
    <h5>O’Neale’s</h5>
    <p class="padding">Derry</p>
    <h5>O’Regan</h5>
    <p class="padding">
      Charlemont
      <br />Sligo (1691)
    </p>
    <h5>Cormack ONeill’s</h5>
    <p class="padding">Althone</p>
    <h5>Gordon O’Neill’s</h5>
    <p class="padding">
      Aughrim
      <br />Limerick (1691)
      <br />Red turned back red
    </p>
    <h5>Oxburgh’s</h5>
    <p class="padding">
      Bir Castle
      <br />Ballymore Fort
    </p>
    <h5>Scott’s</h5>
    <p class="padding">Kinsale</p>
    <h5>Slane’s</h5>
    <p class="padding">Aughrim</p>
    <h5>Earl of Westmeath’s</h5>
    <p class="padding">Limerick</p>
    <h5>Wauchope</h5>
    <p class="padding">
      Cavan
      <br />Limerick (1690)
      <br />Althone (1691)
      <br />Limerick (1691)
    </p>
    <br />
    <br />
    <h5>Viscount Montcashel’s (later Lee’s) (entered French Service April 18 1689)</h5>
    <p class="padding">
      Enniskillen
      <br />Newtownbutler
      <br />Crom Castle
      <br />Red turned back ?
    </p>
    <h5>Fielding (later disbanded) (entered French Service April 18 1689)</h5>
    <p class="padding">
      Enniskillen
      <br />Newtownbutler
      <br />Crom Castle
      <br />Red turned back ?
    </p>
    <h5>Dillon (entered French Service April 18 1689)</h5>
    <p class="padding">
      Enniskillen
      <br />Newtownbutler
      <br />Crom Castle
      <br />Red turned back black
    </p>
    <h5>O’Bryan (later Claire’s) (entered French Service April 18 1689)</h5>
    <p class="padding">
      Enniskillen
      <br />Newtownbutler
      <br />Crom Castle
      <br />Red turned back ?
    </p>
    <h5>Richard Butler (later disbanded) (entered French Service April 18 1689)</h5>
    <p class="padding">
      Enniskillen
      <br />Newtownbutler
      <br />Crom Castle
      <br />Red turned back ?
    </p>

    <h4>French (Arrived 19 April 1689 and departed 12 September 1690)</h4>
    <h4>Foot</h4>
    <h5>De Biron</h5>
    <p class="padding">Boyne</p>
    <h5>De Brouilly</h5>
    <p class="padding">Boyne</p>
    <h5>Conrad von Zurlauben's Blue Regiment (Swiss/German)</h5>
    <p class="padding">Boyne</p>

    <h3>Army of William III</h3>
    <h4>Dutch</h4>
    <div class="padding">
      <h4>Horse</h4>

      <h5>William’s Horse Guards</h5>
      <p class="padding">Boyne</p>
      <h5>Boncour’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
      </p>
      <h5>Ginkel’s</h5>
      <p class="padding">
        Boyne
        <br />Althone (1690)
        <br />Aughrimbr Ballymore Fort (1691)
        <br />Galway
      </p>
      <h5>Monopvillian’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
      </p>
      <h5>Nieuwenhuy’s</h5>
      <p class="padding">Boyne</p>
      <h5>Lord Portland’s</h5>
      <p class="padding">
        Boyne
        <br />Aghrim
      </p>
      <h5>Riedesel’s</h5>
      <p class="padding">Boyne</p>
      <h5>Schack’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
      </p>

      <h4>Dragoons</h4>
      <h5>Eppinger’s</h5>
      <p class="padding">
        Boyne
        <br />Duncannon Fort
        <br />Aughrim
      </p>
      <h5>Reidesell’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
      </p>

      <h4>Foot</h4>
      <h5>Dutch Blue Foot Guards</h5>
      <p class="padding">Boyne</p>
      <h5>Brandenburger Foot</h5>
      <p class="padding">Limerick (1690)</p>
      <h5>Cutt’s</h5>
      <p class="padding">
        Aughrim
        <br />Limerick (1690)
        <br />Limerick (1691)
      </p>
      <h5>Van Graben’s</h5>
      <p class="padding">Aughrim</p>
      <h5>Nassau-Saarbrucken-Ottweiler</h5>
      <p class="padding">
        Aughrim
        <br />Limerick (1691)
      </p>
      <h5>Wurtemberg</h5>
      <p class="padding">
        Limerick (1690)
        <br />Cork
        <br />Kinsale
      </p>
      <h5>Tettau</h5>
      <p class="padding">
        Limerick (1690)
        <br />Cork
        <br />Kinsale
      </p>
    </div>

    <h4>Danish</h4>
    <div class="padding">
      <h4>Horse</h4>
      <h5>Donop’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
      </p>
      <h5>Shested’s</h5>
      <p class="padding">Aughrim</p>
      <h5>Juel’s</h5>
      <p class="padding">
        Limerick (1691)
        <br />(? unnamed at Limerick 1690)
      </p>

      <h4>Foot</h4>
      <h5>Foot Guards</h5>
      <p class="padding">Boyne</p>
      <h5>Prince Christian’s</h5>
      <p class="padding">Boyne</p>
      <h5>Dronningen’s (Queen’s)</h5>
      <p class="padding">Boyne</p>
      <h5>Prince Frederick’s</h5>
      <p class="padding">Boyne</p>
      <h5>Funen</h5>
      <p class="padding">Boyne</p>
      <h5>Jutland</h5>
      <p class="padding">Boyne</p>
      <h5>Zealand</h5>
      <p class="padding">
        Boyne
        <br />(? unnamed at Limerick 1690)
        <br />(six unnamed at Aughrim)
        <br />(one unnamed at Althone 1691)
      </p>
    </div>

    <h4>Huguenot</h4>
    <div class="padding">
      <h4>Horse</h4>
      <h5>Duke of Schomberg’s 88-90/ Ruvigny’s 90 on</h5>
      <p class="padding">
        Boyne
        <br />Althone
        <br />Aughrim
        <br />Limerick (1691)
        <br />Grey
      </p>
      <h5>Luistadt</h5>
      <p class="padding">Aughrim</p>
      <h5>Meinhard Schomberg’s</h5>
      <p class="padding">
        Boyne
        <br />Grey
      </p>
      <h5>Montpoullion’s</h5>
      <p class="padding">
        Aughrim
        <br />Grey
      </p>
      <h4>Dragoons</h4>
      <h5>La Forest</h5>
      <p class="padding">
        Cork
        <br />Aughrim
        <br />Grey
      </p>
      <h5>Miremont's</h5>
      <p class="padding">Grey</p>
      <h4>Foot</h4>
      <h5>Caillemote’s/Belcastle’s</h5>
      <p class="padding">
        Boyne
        <br />Limerick (1690)
        <br />Aughrim
        <br />Grey
      </p>
      <h5>Cambon’s</h5>
      <p class="padding">
        Boyne
        <br />Limerick (1690)
        <br />Cork
        <br />Aughrim
        <br />Galway
        <br />Grey
      </p>
      <h5>La Meloniere’s</h5>
      <p class="padding">
        Sligo
        <br />Boyne
        <br />Limerick (1690)
        <br />Cork
        <br />Aughrim
        <br />Grey
      </p>
    </div>

    <h4>English, Irish and Scots Regiments</h4>
    <div class="padding">
      <h4>Horse</h4>
      <h5>Life Guards</h5>
      <p class="padding">Boyne</p>
      <h5>Lord Blaney’s ( Armagh)</h5>
      <p class="padding">
        Coleraine
        <br />Derry Garrison (Mar-Apr 89)
      </p>
      <h5>Byerley’s</h5>
      <p class="padding">Boyne</p>
      <h5>Compton’s</h5>
      <p class="padding">Aughrim</p>
      <h5>Coy’s</h5>
      <p class="padding">Boyne</p>
      <h5>Lanier’s (Queen’s Regiment of Horse)</h5>
      <p class="padding">
        Boyne
        <br />Castle Bir
        <br />Aughrim
      </p>
      <h5>Laggan Horse (Donegal)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>
      <h5>Langston’s</h5>
      <p class="padding">Boyne</p>
      <h5>Murray’s ( Londonderry)</h5>
      <p class="padding">Derry Garrison (Apr-Aug 89)</p>
      <h5>Earl of Oxford’s (Royal Irish Regiment of Horse)</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
        <br />Blue turned back red
      </p>
      <h5>Forward’s (Inishowen)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>
      <h5>Russell’s (Enniskillen)</h5>
      <p class="padding">
        Enniskillen Garrison
        <br />Sligo
        <br />Boyne
      </p>
      <h5>Villier’s</h5>
      <p class="padding">
        Boyne
        <br />Raid of Ballyneety
        <br />Aughrim
        <br />Red turned back red
      </p>
      <h5>Wolseley’s (Enniskillen)</h5>
      <p class="padding">
        Newtown-Butler
        <br />Boyne Althone
        <br />Aughrim
        <br />Red turned back green/red
        breeches
      </p>

      <h4>Dragoons</h4>
      <h5>Cunningham’s (Scots)</h5>
      <p class="padding">
        Aughrim
        <br />Red turned back white
      </p>
      <h5>Cunyngham’s (Enniskillen)</h5>
      <p class="padding">
        Enniskillen
        <br />Garrison
        <br />Boyne
        <br />Aughrim
        <br />Sligo (1691)
        <br />Grey
      </p>
      <h5>Eppinger’s</h5>
      <p class="padding">
        Boyne
        <br />Waterford
      </p>
      <h5>Heyford’s</h5>
      <p class="padding">Boyne</p>
      <h5>Levinson’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
        <br />Limerick (1691)
      </p>
      <h5>Montjoy’s (Tyrone)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>
      <h5>Rawdon’s ( Londonderry)</h5>
      <p class="padding">
        Dromore
        <br />Derry Garrison (Mar-Apr 89)
      </p>
      <h5>Wynne’s (Enniskillen)</h5>
      <p class="padding">
        Enniskillen
        <br />Crom Castle
        <br />Newtownbutler
        <br />Sligo (1689)
        <br />Cavan
        <br />Boyne
        <br />Althone (1691)
        <br />Aughrim
        <br />Grey
      </p>
      <h4>Foot</h4>
      <h5>Princess Anne’s of Denmark’s</h5>
      <p class="padding">
        Boyne
        <br />Corkbr Limerick (1690)
        <br />Kinsale
        <br />Limerick (1691)
        <br />Red turned back yellow/yellow breeches
      </p>
      <br />
      <br />
      <h5>Babington’s (1688-91)/ Prince George of Hesse-Darmstadt 91 on</h5>
      <p class="padding">
        Carrickfergus
        <br />Boyne
        <br />Althone (1691)
        <br />Aughrim
        <br />Limerick (1691)
      </p>
      <h5>Baker’s ( Londonderry)</h5>
      <p class="padding">
        Derry Garrison (Mar-Apr 89)
        <br />Derry Garrison (Apr-Aug 89)
      </p>
      <h5>Beaumont’s</h5>
      <p class="padding">
        Aughrim
        <br />Limerick (1691)
      </p>
      <h5>Beresford (Antrim)</h5>
      <p class="padding">Coleraine</p>
      <h5>Lord Blaney’s ( Armagh)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>
      <h5>Bolton’s</h5>
      <p class="padding">
        Cork
        <br />Kinsale
      </p>
      <h5>Brewer</h5>
      <p class="padding">
        Aughrim
        <br />Galway
      </p>
      <h5>Canning/Crofton ( Londonderry)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>
      <h5>Lord Charlemont’s ( Londonderry)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>
      <h5>Chichester’s (Dungannon)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>
      <h5>Churchill’s</h5>

      <p class="padding">
        Cork
        <br />Kinsale
      </p>

      <h5>Coldstream Guards</h5>
      <p class="padding">Boyne</p>
      <h5>Coleraine ( Londonderry)</h5>
      <p class="padding">Derry (Mar-Apr 89)</p>
      <h5>Collier’s</h5>
      <p class="padding">
        Cork
        <br />Limerick (1691)
      </p>
      <h5>Colyear</h5>
      <p class="padding">
        Cork
        <br />Kinsale
        <br />Red turned back yellow
      </p>
      <h5>Corry (Enniskillen)</h5>
      <p class="padding">Enniskillen Garrison</p>

      <br />
      <br />

      <h5>Douglas’ (Scots Guards)</h5>
      <p class="padding">
        Boyne
        <br />Limerick (1690)
        <br />Althone (1690)
        <br />Bir Castle
        <br />Jamestown
        <br />Ballimore
        <br />Red turned back white/white
        breeches
      </p>

      <h5>Earl of Drogheda’s ( Belfast)</h5>
      <p class="padding">
        Boyne
        <br />Blue
      </p>

      <h5>Edmonstone’s (Antrim)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>

      <h5>Erle’s (Irish)</h5>
      <p class="padding">
        Limerick (1690)
        <br />Aughrim
      </p>
      <h5>First Guards</h5>
      <p class="padding">Boyne</p>

      <h5>Fitzpatrick’s</h5>
      <p class="padding">Cork</p>

      <h5>Foulke’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
        <br />Limerick (1691)
      </p>

      <h5>Garvagh’s (Derry)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>

      <h5>Hales’s</h5>
      <p class="padding">
        Cork
        <br />Red turned back red
      </p>

      <h5>Hamill’s</h5>
      <p class="padding">
        Derry Garrison (Mar-Apr 89)
        <br />Derry Garrison (Apr-Aug 89)
      </p>

      <h5>Gustavus Hamilton’s 89-90/ Creighton’s 90 on (Enniskillen)</h5>
      <p class="padding">
        Enniskillen
        <br />Crom Castle
        <br />Newtown-Butler
        <br />Aughrim
      </p>

      <h5>Gustavus Hamilton’s 89 (augmented by 6 companies of Montjoy’s)</h5>
      <p class="padding">
        Boyne
        <br />Allthone
        <br />Limerick (1690)
        <br />Aughrim
        <br />Limerick (1691)
        <br />Red turned back red
      </p>

      <h5>Hanmer’s</h5>
      <p class="padding">
        Relief of Derry
        <br />Boyne Althone (1691)
        <br />Limerick (1691)
        <br />Red turned back
        red or tawney (?)
      </p>

      <br />
      <br />
      <h5>Hasting’s</h5>
      <p class="padding">
        Killiekrankie (Scotland)
        <br />Boyne
        <br />Cork
        <br />Kinsale
        <br />Red turned back yellow with
        yellow breeches
      </p>

      <h5>Herbert’s</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
        <br />Galway
        <br />Blue turned back white
      </p>

      <h5>Johnson’s (Tyrone)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>

      <h5>Kirke’s (Queen Dowager’s Regiment)</h5>
      <p class="padding">
        Relief of Derry
        <br />Boyne
        <br />Limerick (1690)
        <br />Bir Castle
        <br />Waterford
        <br />Aughrim
        <br />Red turned back green/green breeches
      </p>

      <h5>Lisburn’s (Newtonbutler)</h5>
      <p class="padding">
        Boyne
        <br />Lanesborough
        <br />Aughrim
      </p>

      <h5>Lloyd’s (Enniskillen) 89-90/ George Hamilton’s 90 on</h5>
      <p class="padding">
        Enneskillen
        <br />Newtown-Butler
        <br />Ballyshannon
        <br />Sligo (1689)
        <br />Ballysadare
        <br />Boyne
        <br />Aughrim
        <br />Galway
        <br />Limerick
        (1691)
        <br />Red turned back green
      </p>

      <h5>Luttrell’s (1688-91)</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
        <br />Blue turned back yellow 1688-89
        <br />Red turned
        back yellow 1689 on
      </p>

      <h5>Marlborough’s</h5>
      <p class="padding">Cork</p>

      <h5>Maxwell’s (Down)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>

      <h5>Edgeworth’s/Earl of Meath’s (Irish)</h5>
      <p class="padding">
        Carrickfergus
        <br />Boyne
        <br />Limerick (1690)
        <br />Aughrim
        <br />Limerick (1691)
      </p>

      <h5>Melville’s (Earl of Leven) (Scots)</h5>
      <p class="padding">
        Killiecrankie ( Scotland)
        <br />Ballymore
        <br />Althone
        <br />Aughrim
        <br />Galway
        <br />Limerick
        (1691)
        <br />Red turned back yellow
      </p>

      <h5>Mervin’s (Armagh)</h5>
      <p class="padding">Derry Garrison (Mar- Apr 89)</p>

      <h5>Monmouth’s</h5>
      <p class="padding">
        Cork
        <br />Kinsale
      </p>

      <h5>Montjoy’s (6 companies augmented Gustavus Hamilton’s)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>

      <h5>Murray’s (Londonderry)</h5>
      <p class="padding">
        Siege of Derry (Apr-Aug 89)
        <br />Pennyburn Mill
      </p>

      <h5>Duke of Norfolk’s 89/Bellasis 89 on</h5>
      <p class="padding">
        Carrickfergus
        <br />Boyne
        <br />Althone
        <br />Aughrim
        <br />Galway
        <br />Red turned
        back buff
      </p>

      <h5>O’Donnell ( Ulster) Went over to William III at Sligo</h5>
      <p class="padding">Sligo (1691)</p>

      <h5>Parker’s/Lance’s (Coleraine)</h5>
      <p class="padding">
        Derry Garrison (Mar-Apr 89)
        <br />Pennyburn Mill
        <br />Derry Garrison (Apr-Aug 89)
      </p>

      <h5>Phillip’s ( Londonderry)</h5>
      <p class="padding">Derry Garrison (Mar-Apr 89)</p>

      <h5>
        Skeffington’s Jan-Aug 1689/ Mitchelburne’s Londonderry (Antrim
        Volunteers)
      </h5>
      <p class="padding">
        Derry Garrison (Mar-Apr 89)
        <br />Windmill Hill
        <br />Derry Garrison (Apr-Aug 89)
        <br />Boyne
        <br />Sligo (1691)
      </p>

      <h5>Steuart’s</h5>
      <p class="padding">
        Relief of Derry Garrison
        <br />Boyne
        <br />Limerick (1690)
        <br />Aughrim
        <br />Red turned back
        tawney
      </p>

      <h5>St George’s</h5>
      <p class="padding">Relief of Derry</p>

      <h5>Charlemont’s/Baker’s/ St John’s (Londonderry)</h5>
      <p class="padding">
        Dromore
        <br />Derry Garrison (Mar-Apr 89)
        <br />Windmill Hill
        <br />Derry
        Garriosn (Apr-Aug 89)
        <br />Boyne
        <br />Aughrim
        <br />Galway
      </p>

      <h5>Tiffin’s (Enniskillen)</h5>
      <p class="padding">
        Enniskillen Garrison
        <br />Newtown-butler
        <br />Ballyshannon
        <br />Sligo (1689)
        <br />Derry
        <br />Boyne
        <br />Castle Birr
        <br />Aughrim
        <br />Galway
        <br />Limerick
        (1691)
        <br />Grey turned back white
      </p>

      <h5>Torrington’s</h5>
      <p class="padding">
        Cork
        <br />Kinsale
      </p>

      <h5>Trelawney’s (Queen Consort’s Regiment)</h5>
      <p class="padding">
        Boyne
        <br />Cork
        <br />Kinsale
        <br />Limerick (1691)
        <br />Red turned back
        yellow/yellow breeches
      </p>

      <h5>Verner’s</h5>
      <p class="padding">Limerick (1691)</p>

      <h5>Rawdon’s/Walkers/White’s/Caulfield’s (Londonderry)</h5>
      <p class="padding">
        Dromore
        <br />Coleraine
        <br />Derry Garrison (Mar-Aug 89)
        <br />Windmill Hill
        <br />Derry Garrison (Apr-Aug 89)
        <br />Retained after Siege
      </p>

      <h5>Winchester’s</h5>
      <p class="padding">Cork</p>

      <h5>Wharton’s (89)/ Brewer’s (89 on)</h5>
      <p class="padding">
        Boyne
        <br />Aughrim
      </p>

      <h5>Whitney’s/Monro’s ( Londonderry)</h5>
      <p class="padding">Derry Garrison (Apr-Aug 89)</p>
    </div>
    <div class="image">
      <img
        src="@/assets/images/IrishHistory/enniskillen.jpg"
        alt="Raising the Enniskillen Regiment"
      />
      <i>
        <h5>Raising the Enniskillen Regiment</h5>
      </i>
    </div>
    <h4>Battles and Sieges</h4>2 March 1689 Justin McCarthy occupies Bandon
    <br />
    <br />12 March 1689 King James II lands at Kinsale
    <br />
    <br />December - August 1689 Actions around Enniskillen by Enniskillen
    forces
    <br />
    <br />18 December 2 companies established under Cpts. Allen and Malcome
    Cathcart
    <br />
    <br />January Enniskillen Regt formed under Col. Gustavus Hamilton and LTC
    Lloyd
    <br />
    <br />20-24 Mar Siege of Crom Castle
    <br />
    <br />24 Apr Raid on Omagh
    <br />
    <p class="padding">
      Burning of Augher
      <br />Raid on Monaghan
    </p>
    <br />
    <br />4 May Belleek
    <br />
    <br />Late May Redhill
    <br />
    <p class="padding">
      Ballynacarrig
      <br />Kells
      <br />Finna
    </p>
    <br />
    <br />3 June Raid on Omagh
    <br />
    <br />11 June Raid on Omagh
    <br />
    <br />17 June Belturbet
    <br />
    <br />8 July Cornegrade
    <br />
    <br />20 July Enniskillen organizes into Wolsely’s Horse, Wynne’s Dragoons,
    Hamilton’s Foot, Lloyd’s Foot and Tiffins’s Foot
    <br />
    <br />31 July Crom Castle
    <br />
    <p class="padding">
      Lisnaskea
      <br />Newtown-Butler
    </p>
    <br />
    <br />18 April - 1 August 1689 Siege of Derry
    <h4>Actions around Derry by Regiments in Derry</h4>14 March 1689 Dromore
    <br />
    <br />27 March 1689 Coleriane
    <br />
    <br />14 April 1689 Cladyford
    <br />
    <br />21 April Pennyburn Mill
    <br />
    <br />5 May Windmill Hill
    <br />
    <br />28 June Butchers Gate at Derry
    <br />
    <br />4 June Windmill Hill
    <br />
    <br />May 1689 Ballyshannon
    <br />
    <br />1 May- 30 Sep 1689 operations around Sligo
    <br />
    <br />May 1689 – 14 June 1690 Siege of Charlemont
    <br />
    <br />13 August 1689 Schomberg lands at Bangor Bay
    <br />
    <br />20-27 August 1689 Siege of Carrickfergus
    <br />
    <br />21 September 1689 Dundalk
    <br />
    <br />January 1690 Siege of Kenagh Castle
    <br />
    <br />7 June 1690 Ballymore Fort
    <br />
    <br />14 June 1690 William III lands at Carrickfergus
    <br />
    <br />22 June 1690 Skirmish at Moyry Pass
    <br />
    <br />22 June 1690 Newry
    <br />
    <br />1 July 1690 Battle of the Boyne
    <br />
    <br />17-24 July 1690 Siege of Althone
    <br />
    <br />21-26 July 1690 Siege of Duncannon Fort
    <br />
    <br />23-24 July 1690 Siege of Waterford
    <br />
    <br />9-30 August 1690 Siege of Limerick
    <br />
    <br />13 August 1690 Ballineety Raid
    <br />
    <br />Sep 1690 Althone
    <br />
    <br />12 September 1690 Castle Birr
    <br />
    <br />28 September 1690 Cork
    <br />
    <br />3 October 1690 Kinsale
    <br />
    <br />December 1690 Jamestown
    <br />
    <br />27 December 1690 - 8 January 1691 Lanesborough
    <br />
    <br />21-30 June 1691 Siege of Althone
    <br />
    <br />June 1691 Ballymore Fort
    <br />
    <br />12 July 1691 Aughrim
    <br />
    <br />19- 28 July 1691 Galway
    <br />
    <br />25 August – 3 October 1691 Siege of Limerick
    <br />
    <br />10 - 15 September 1691 Seige of Sligo
    <div class="image">
      <img src="@/assets/images/IrishHistory/boyne.jpg" alt="Battle of the Boyne" />
      <i>
        <h5>Battle of the Boyne</h5>
      </i>
    </div>
    <i>
      <h4>The Boyne Water</h4>
      <br />July the first, of a morning clear, one thousand six hundred and
      ninety,
      <br />King William did his men prepare—of thousands he had thirty-
      <br />To fight King James and all his foes, encamped near the Boyne Water;
      <br />He little feared, though two to one, their multitude to scatter.
      <br />
      <br />King William called his officers, saying: "Gentlemen, mind your
      station,
      <br />And let your valour here be shown before this Irish nation;
      <br />My brazen walls let no man break, and your subtle foes you’ll
      scatter,
      <br />Be sure you show them good English play as you go over the
      water."
      <br />
      <br />Both foot and horse they marched on, intending them to batter,
      <br />But the brave Duke Schomberg he was shot as he crossed over the
      water.
      <br />When that King William did observe the brave Duke Schomberg
      falling,
      <br />He reined his horse with a heavy heart, on the
      Enniskillenes calling:
      <br />
      <br />"What will you do for me, brave boys—see yonder men retreating?
      <br />Our enemies encouraged are, and English drums are beating."
      <br />He
      says, "My boys feel no dismay at the losing of one commander,
      <br />For
      God shall be our King this day, and I'll be general under."
      <br />
      <br />Within four yards of our fore-front, before a shot was fired,
      <br />A sudden snuff they got that day, which little they desired;
      <br />For horse and man fell to the ground, and some hung on their saddle:
      <br />Others turned up their forked ends, which we call coup de ladle.
      <br />
      <br />Prince Eugene's regiment was the next, on our right hand advanced
      <br />Into a field of standing wheat, where Irish horses pranced;
      <br />But the brandy ran so in their heads, their senses all did scatter,
      <br />They little thought to leave their bones that day at the Boyne
      Water.
      <br />
      <br />Both men and horse lay on the ground, and many there lay bleeding,
      <br />I saw no sickles there that day—but, sure, there was sharp shearing.
      <br />Now, praise God, all true Protestants, and heaven's and earth's
      Creator,
      <br />For the deliverance he sent our enemies to scatter.
      <br />The Church's foes will pine away, like churlish-hearted Nabal,
      <br />For our deliverer came this day like the great Zorobabal.
      <br />
      <br />So praise God, all true Protestants, and I will say no further,
      <br />But had the Papists gained that day, there would have been open
      murder.
      <br />Although King James and many more were ne'er that way
      inclined,
      <br />It was not in their power to stop what the rabble they
      designed.
    </i>
    <div class="image">
      <img
        src="@/assets/images/IrishHistory/wick.jpeg"
        alt="Jan Wyck’s Painting of the Battle of the Boyne"
      />
      <i>
        <h5>Jan Wyck’s Painting of the Battle of the Boyne</h5>
      </i>
    </div>
    <i>
      <h4>Lillibulero</h4>

      <br />Ho! brother Teague, dost hear the decree?
      <br />Lillibulero bullen a
      la, (repeated after each line)
      <br />Dat we shall have a new deputy?
      <br />Lillibulero bullen a la.
      <br />
      <br />Refrain:
      <br />Lero, lero, lillibulero,
      <br />lillibulero, bullen a
      la
      <br />Lero, lero, lillibulero,
      <br />lillibulero, bullen a la.
      <br />
      <br />Ho! by my soul, it is de Talbot,
      <br />And he will cut all de
      English throat.
      <br />
      <br />Though, by my soul, de English do praat,
      <br />De law's on dare
      side, and Creish knows what.
      <br />
      <br />But if dispence do come from de Pope,
      <br />We'll hang Magna Charta
      and dem in a rope.
      <br />
      <br />And de good Talbot is made a Lord,
      <br />And with brave lads is
      coming abroad.
      <br />
      <br />Who all in France have taken a sware,
      <br />Dat dey will have no
      Protestant heir.
      <br />
      <br />Ara! but why does he stay behind?
      <br />Ho' by my soul, 'tis a
      Protestant wind!
      <br />
      <br />But see, de Tyrconnel is now come ashore,
      <br />And we shall have
      commissions galore.
      <br />
      <br />And he dat will not go to mass
      <br />Shall be turn out, and look
      like an ass.
      <br />
      <br />But now de hereticks all go down,
      <br />By Creish and St. Patrick,
      de nation's our own.
      <br />
      <br />Dare was an old prophecy found in a bog,
      <br />" Ireland shall be
      ruled by an ass and a dog".
      <br />
      <br />And now dis prophecy is come to pass,
      <br />For Talbot's de dog, and
      James is de ass.
    </i>
    <hr />
    <h3>Sources:</h3>
    <ol>
      <li>
        Doherty, Richard, The Williamite War in Ireland, 1688-1691 ( Ireland,
        1998)
      </li>
      <li>
        Ede-Borrett, S., The Army of James II, Uniforms and Organization ( UK,
        2003)
      </li>
      <li>
        Berresford-Ellis, Peter, The Boyne Water, The Battle of the Boyne, 1690
        ( Belfast, 1989)
      </li>
      <li>
        Glozier, Matthew, The Huguenot Soldiers of William of Orange and the
        “Glorious Revolution” of 1688 ( UK, 2002)
      </li>
      <li>Hamilton, Andrew, The Actions of the Enniskillen-Men ( London, 1690)</li>
      <li>Kinross, John, The Boyne and Aughrim, The War of Two Kings ( UK, 1997)</li>
      <li>Lenihan, Padraig, 1690: Battle of the Boyne ( UK, 2003)</li>
      <li>Macrory, Patrick, The Siege of Derry (NY 1980)</li>
      <li>McNally Michael, Battle of the Boyne, 1690 ( UK, 2005)</li>
      <li>Reid, Stuart, The Last Scots Army, 1661-1714 (UK 2003)</li>
      <li>Sapherson, C.A., The British Army of William III ( UK, 1997)</li>
      <li>
        Sapherson, C.A., William III At War Scotland and Ireland 1689-1691 ( UK,
        2001)
      </li>
      <li>Simms, J.G., Jacobite Ireland ( Dublin, 2000)</li>
      <li>
        Wauchope, Piers, Patrick Sarsfield and the Williamite War ( Dublin,
        1992)
      </li>
      <li>
        Williams, Noel St John, Redcoats and Courtesans, the Birth of the
        British Army, 1660-1690 ( London, 1994)
      </li>
      <li>
        Witherow, Thomas, Derry and Enniskillen in the Year 1689 ( Belfast,
        1913)
      </li>
      <li>
        A Jacobite narrative of the war in Ireland , A light to the blind,
        Plunkett memoirs
      </li>
      <li>A List of Officers taken at Ballymore, the 8th of June, 1691</li>
      <li>
        Contemporary Diary of Siege of Limerick, 1691, by Colonel Michael
        Richards
      </li>
    </ol>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h4 {
  margin-bottom: 0;
}
p {
  margin: 0;
}
</style>
